export type FlightInfo = {
  id: number
  batch_id: number
  origin: string | null
  origin_iata: string | null
  origin_name: string | null
  destination: string | null
  destination_iata: string | null
  destination_name: string | null
  flight_number: string | null
  type: string | null
  status: string | null
  // NOTE: format: '2025-07-19T14:38:00+09:00'
  ata: string | null
  atd: string | null
  eta: string | null
  etd: string | null
  sta: string | null
  std: string | null
  est_duration: number | null
  layover_duration: number | null
}

export const MAWB_REGEX = /^\d{3}-\d{8}$/ // 3 digits + '-' + 8 digits
